(function() {
  'use strict';
  
  angular
    .module('app.validators')
    .directive('maxLines', maxLines);
      
    maxLines.$inject = [];
    
  function maxLines() {
    
    var directive = {
      require: 'ngModel',      
      link: link,
      restrict: 'A'
    }
    return directive;
    
    function link(scope, ele, attrs, ngModel) {
      function lessThanMaxLines(text) {
        var valid = text.split(/\r\n|\n|\r/).length <= attrs.maxLines;
        ngModel.$setValidity('lineLimit', valid);
        return valid ? text : undefined;
      }
      ngModel.$parsers.push(lessThanMaxLines);
    }
  }
  
})();